import { render, staticRenderFns } from "./ItemListViewTable.vue?vue&type=template&id=09d532bc&scoped=true"
import script from "./ItemListViewTable.vue?vue&type=script&lang=ts"
export * from "./ItemListViewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d532bc",
  null
  
)

export default component.exports